import React, { useEffect, useState } from 'react';
import './Hero.css';
import heartIcon from '../Assets/Hero/heart.webp';
import meatIcon from '../Assets/Hero/meat.webp';
import leafIcon from '../Assets/Hero/leaf.webp';
import shieldIcon from '../Assets/Hero/shield.webp';
import pawIcon from '../Assets/Hero/paw.webp';
import heroImg from '../Assets/Hero/Hero.webp';
import crownIcon from '../Assets/Hero/crown.webp';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation slightly after mount
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="hero4-wrapper">
      <div className="hero4-main-content">
        
        {/* Left Column */}
        <div className="hero4-text-side">
          <div className="hero4-subtitle">HEALTH FIRST. ALWAYS.</div>
          
          <h1 className="hero4-heading">
            <span className="hero4-heading-top">
              We Don't Chase Price.
            </span>
            <br />
            We Choose{' '}
            <span className="hero4-health-first hero4-red-text">
              Better Pet Health.
              <svg className={`hero4-curve ${animate ? 'animate' : ''}`} viewBox="0 0 200 20" preserveAspectRatio="none">
                <path d="M 0,18 Q 100,-2 195,15" fill="none" stroke="#A71B20" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </span>
          </h1>

          <div className="hero4-divider">
            <div className="hero4-divider-line"></div>
            <img src={crownIcon} alt="Crown" className="hero4-divider-icon" />
            <div className="hero4-divider-line"></div>
          </div>

          <p className="hero4-desc">
            Every product is created with carefully selected ingredients<br/>
            to support lifelong wellness and everyday vitality.
          </p>

          <div className="hero4-buttons">
            <button className="hero4-cta" onClick={() => navigate('/products')}>
              Explore Our Nutrition
            </button>
            <button className="hero4-cta-outline" onClick={() => navigate('/contact')}>
              Contact Us
            </button>
          </div>

          <div className="hero4-trust">
            <div className="hero4-avatars">
              <img src="https://caninecrown.ascentbw.com/Image/Home/Tes1.webp" alt="Parent 1" />
              <img src="https://caninecrown.ascentbw.com/Image/Home/Tes2.webp" alt="Parent 2" />
              <img src="https://caninecrown.ascentbw.com/Image/Home/Test3.webp" alt="Parent 3" />
              <img src="https://caninecrown.ascentbw.com/Image/Home/Tes4.webp" alt="Parent 4" />
            </div>
            <div className="hero4-trust-text">
              <div className="hero4-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} width="16" height="16" viewBox="0 0 24 24" fill="#FFC107" stroke="#FFC107" strokeWidth="1">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                ))}
              </div>
              <span>Trusted by 10,000+ Pet Parents</span>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className={`hero4-image-side ${animate ? 'animate' : ''}`}>
          <img src={heroImg} alt="Kitten and Puppy" className="hero4-main-img" />
        </div>
      </div>

      {/* Features Bar */}
      <div className="hero4-features-container">
        <div className="hero4-feature-box">
          <div className="hero4-feature-icon">
            <img src={heartIcon} alt="Health" className="hero4-icon-img" />
          </div>
          <div className="hero4-feature-info">
            <h4>Health First</h4>
            <p>Every recipe begins with<br/>your pet's well-being.</p>
          </div>
        </div>
        
        <div className="hero4-feature-divider"></div>

        <div className="hero4-feature-box">
          <div className="hero4-feature-icon">
            <img src={meatIcon} alt="Protein" className="hero4-icon-img" />
          </div>
          <div className="hero4-feature-info">
            <h4>Protein Rich Recipes</h4>
            <p>High-quality protein for<br/>strength and vitality.</p>
          </div>
        </div>

        <div className="hero4-feature-divider"></div>

        <div className="hero4-feature-box">
          <div className="hero4-feature-icon">
             <img src={leafIcon} alt="Natural" className="hero4-icon-img" />
          </div>
          <div className="hero4-feature-info">
            <h4>Natural Ingredients</h4>
            <p>Carefully selected ingredients<br/>for balanced nutrition.</p>
          </div>
        </div>

        <div className="hero4-feature-divider"></div>

        <div className="hero4-feature-box">
          <div className="hero4-feature-icon">
             <img src={shieldIcon} alt="Quality" className="hero4-icon-img" />
          </div>
          <div className="hero4-feature-info">
            <h4>Quality Assured</h4>
            <p>Carefully selected ingredients<br/>for balanced nutrition.</p>
          </div>
        </div>

        <div className="hero4-feature-divider"></div>

        <div className="hero4-feature-box">
          <div className="hero4-feature-icon">
             <img src={pawIcon} alt="Loved" className="hero4-icon-img" />
          </div>
          <div className="hero4-feature-info">
            <h4>Loved by Pets</h4>
            <p>Made with care for happier<br/>dogs and cats.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
